module.exports = __webpack_public_path__ + "82b9c7a5a3f405032b1db71a25f67021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 222
// module chunks = 3